import { DhamhaAungLanLogo } from "@/components/common/icons";
import { COOKIE_MAX_AGE, COOKIE_REMEMBER_ME } from "@/constants";
import { loginRequestSchema } from "@/constants/zod-schemas";
import { useLogin } from "@/hooks/query-hooks/useAuth";
import { Button, Checkbox, Form, FormProps, Input } from "antd";
import FormItem from "antd/es/form/FormItem";
import Cookies from "js-cookie";
import { AiOutlineLock, AiOutlinePhone } from "react-icons/ai";
import { Link } from "react-router";

type FieldType = {
    phone: string;
    password: string;
    rememberMe?: boolean;
}

export function LoginForm() {

    const [form] = Form.useForm<FieldType>();
    const { mutate, isLoading } = useLogin();

    const onFinish: FormProps<FieldType>['onFinish'] = (values: FieldType) => {

        const { phone, password, rememberMe } = values;

        Cookies.set(COOKIE_REMEMBER_ME, rememberMe ? "true" : "false", {
            expires: rememberMe ? COOKIE_MAX_AGE : undefined, // 7 days if rememberMe is true
            sameSite: "Strict",
        });
        const payload = loginRequestSchema.parse({
            phone,
            password,
        })
        mutate(payload);
    }

    return (
        <div
            className="max-w-md w-full p-8 rounded-md bg-white backdrop-blur-md shadow-lg space-y-8"
        >
            <article
                className=" space-y-4 flex flex-col items-center"
            >
                <DhamhaAungLanLogo />
                <h2
                    className="text-base text-primary-gradient"
                >
                    ဓမ္မအောင်လံ ဝိပဿနာရိပ်သာ
                </h2>
                <p
                    className="uppercase font-poppins"
                >
                    Admin Dashboard
                </p>
            </article>
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={{
                    rememberMe: true
                }}
            >
                <Form.Item<FieldType>
                    name={"phone"}
                    rules={[
                        {
                            required: true, message: "Required!"
                        },
                        {
                            pattern: /^09\d{6,9}$/,
                            message: "Invalid phone number format!"
                        }
                    ]}
                >
                    <Input
                        prefix={
                            <AiOutlinePhone
                                className="mr-2"
                            />
                        }
                        placeholder="Phone number"
                        size="large"
                    />
                </Form.Item>

                <Form.Item<FieldType>
                    name={"password"}
                    rules={[
                        {
                            required: true, message: "Required!"
                        }
                    ]}
                >
                    <Input.Password
                        prefix={
                            <AiOutlineLock
                                className="mr-2"
                            />
                        }
                        placeholder="Password"
                        size="large"
                    />
                </Form.Item>
                <div
                    className="mb-4 flex items-center justify-between"
                >
                    <FormItem<FieldType>
                        name={"rememberMe"}
                        valuePropName={Cookies.get(COOKIE_REMEMBER_ME) === "true" || !Cookies.get(COOKIE_REMEMBER_ME) ? "checked" : undefined}
                        className="!mb-0"
                    >
                        <Checkbox>
                            Remember me
                        </Checkbox>
                    </FormItem>
                    <Link
                        to={"/forgot-password"}
                    >
                        Forgot password?
                    </Link>
                </div>
                <Button
                    block
                    type="primary"
                    size="large"
                    htmlType="submit"
                    className="bg-primary-gradient !text-white !font-poppins"
                    loading={isLoading}
                >
                    Log in
                </Button>
            </Form>
        </div>
    )
}
